import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import AppDatePicker from "@/features/line-sheet-sets/app-date-picker";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { ORDER_HISTORY_KEY } from "@/features/pathpick/features/order-history/constants";

interface Props {
  startDate?: Date;
  endDate?: Date;
  onChangeStartDate: (value: Date | undefined) => void;
  onChangeEndDate: (value: Date | undefined) => void;
  // "row"는 데스크탑 인라인 필터 줄, "column"은 모바일 필터 모달 안.
  direction?: "row" | "column";
}

// 주문일 범위 두 칸 — 인라인 필터 줄과 모바일 필터 모달이 같은 컴포넌트를 쓴다.
// 값은 양쪽 모두 usePathPickOrderHistoryFilter(쿼리스트링)가 소유하므로,
// 어느 쪽에서 고르든 같은 상태가 즉시 바뀐다.
function PathPickOrderHistoryDateRangeFields({
  startDate,
  endDate,
  onChangeStartDate,
  onChangeEndDate,
  direction = "row",
}: Props) {
  const { t } = useI18nHelper();
  const isColumn = direction === "column";

  return (
    <Flex
      flexDirection={isColumn ? "column" : "row"}
      gap={"8px"}
      alignItems={isColumn ? "stretch" : "center"}
    >
      <Box width={isColumn ? "100%" : "140px"}>
        <AppDatePicker
          name={t(`${ORDER_HISTORY_KEY}date_start`)}
          value={startDate}
          onChange={onChangeStartDate}
          showTimeInput={false}
          maxDate={endDate}
        />
      </Box>
      {/* 세로 스택에서는 두 칸 사이의 "~"가 구분자로 읽히지 않는다 */}
      {!isColumn && (
        <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
          ~
        </Text>
      )}
      <Box width={isColumn ? "100%" : "140px"}>
        <AppDatePicker
          name={t(`${ORDER_HISTORY_KEY}date_end`)}
          value={endDate}
          onChange={onChangeEndDate}
          showTimeInput={false}
          minDate={startDate}
        />
      </Box>
    </Flex>
  );
}

export default PathPickOrderHistoryDateRangeFields;
